import React, { useState, useEffect } from "react";
import { Card, Form, Button, Row, Col, Table, Modal } from "react-bootstrap";
import Layout from "../../layout/Layout";
import { useAuth } from "../../context/AuthContext";
import { FiEdit } from "react-icons/fi";
import Select from "react-select";
import {
  setReminderDocument,
  getReminderDocuments,
  getUserlist,
  upsertReminderDocuments,
} from "../../../api/reminderDocumentApi";
import { eksikAlanlar, yuklemeHataMesaji } from "../../../utils/yuklemeHata";

function ReminderDocument() {
  const { user } = useAuth();
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [editMode, setEditMode] = useState(false);

  const [feedback, setFeedback] = useState({
    show: false,
    type: "success",
    message: "",
  });

  const [newDoc, setNewDoc] = useState({
    name: "",
    description: "",
    category: "document",
    createdDate: "",
    endDate: "",
    notifyBefore: [],
    responseblePersonel: [],
    file: null,
  });

  const [docs, setDocs] = useState([]);

  useEffect(() => {
    const fetchDocs = async () => {
      try {
        const res = await getReminderDocuments();
        if (res.data.statusCode === 200) {
          setDocs(res.data.data);
        }
      } catch (err) {
        console.error("Belgeler çekilemedi:", err);
      }
    };
    fetchDocs();
  }, []);

  const filteredDocs = docs.filter(
    (d) =>
      d.name.toLowerCase().includes(search.toLowerCase()) ||
      d.description?.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    async function fetchUsers() {
      try {
        const res = await getUserlist();
        if (res.data.statusCode === 200) {
          setUsers(res.data.data); //  backend'den gelen data
        }
      } catch (err) {
        console.error("User listesi alınamadı:", err);
      }
    }
    fetchUsers();
  }, []);

  const handleUserChange = (selected) => {
    setNewDoc((prev) => ({
      ...prev,
      responseblePersonel: selected.map((s) => ({
        personelId: s.value,
        isActive: true,
        createdAt: new Date(),
      })),
    }));
  };

  const userOptions = users.map((u) => ({
    value: u._id,
    label: `${u.name} ${u.surname}`,
  }));

  const handleShow = () => {
    setEditMode(false); // yeni kayıt açılacak
    setNewDoc({
      updatedId: null,
      name: "",
      description: "",
      category: "document",
      createdDate: "",
      endDate: "",
      notifyBefore: [],
      responseblePersonel: [],
      file: null,
    });
    setShowModal(true);
  };

  const handleEdit = (doc) => {
    setEditMode(true); // düzenleme moduna geç
    setNewDoc({
      updatedId: doc._id,
      name: doc.name || "",
      description: doc.description || "",
      category: doc.category || "document",
      createdDate: doc.createdDate ? doc.createdDate.slice(0, 10) : "",
      endDate: doc.endDate ? doc.endDate.slice(0, 10) : "",
      notifyBefore: doc.notifyBefore || [],
      responseblePersonel: doc.responseblePersonel || [],
      fileName: doc.fileName || "", 
      file: null,
    });
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setNewDoc({
      name: "",
      description: "",
      category: "document",
      createdDate: "",
      endDate: "",
      notifyBefore: [],
      responseblePersonel: [],
      file: null,
    });
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "file") {
      setNewDoc((prev) => ({ ...prev, file: files[0] }));
    } else if (name === "notifyBefore") {
      const arr = value
        .split(",")
        .map((v) => parseInt(v.trim()))
        .filter((v) => !isNaN(v));
      setNewDoc((prev) => ({ ...prev, notifyBefore: arr }));
    } else {
      setNewDoc((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSave = async () => {
    if (!user) {
      alert("Önce giriş yapmalısınız!");
      return;
    }
    // bu ekranda başlık "name" alanında; dosya güncellemede isteğe bağlı
    const eksik = eksikAlanlar({ title: newDoc.name, file: newDoc.file }, { dosyaZorunlu: false });
    if (eksik) {
      setFeedback({ show: true, type: "error", message: eksik });
      return;
    }

    try {
      const formData = new FormData();
      formData.append("personelId", user._id || user.id);

      if (newDoc.updatedId) {
        formData.append("updatedId", newDoc.updatedId); // update için
      }

      if (newDoc.name) formData.append("name", newDoc.name);
      if (newDoc.description)
        formData.append("description", newDoc.description);
      if (newDoc.createdDate)
        formData.append("createdDate", newDoc.createdDate);
      if (newDoc.endDate) formData.append("endDate", newDoc.endDate);

      formData.append("category", newDoc.category || "document");
      formData.append(
        "notifyBefore",
        JSON.stringify(
          newDoc.notifyBefore.length ? newDoc.notifyBefore : [7, 1]
        )
      );
      formData.append(
        "responseblePersonel",
        JSON.stringify(newDoc.responseblePersonel || [])
      );

      if (newDoc.file) {
        formData.append("file", newDoc.file);
      }

      let result;
      if (newDoc.updatedId) {
        //  Güncelleme
        result = await upsertReminderDocuments(formData);
      } else {
        //  Yeni kayıt
        result = await setReminderDocument(formData);
      }

      if (result.data.statusCode === 200) {
        const res = await getReminderDocuments();
        if (res.data.statusCode === 200) {
          setDocs(res.data.data);
        }

        handleClose();
        setFeedback({
          show: true,
          type: "success",
          message: newDoc.updatedId
            ? "Belge başarıyla güncellendi "
            : "Dosya başarıyla yüklendi ",
        });
      } else {
        setFeedback({
          show: true,
          type: "error",
          message: "İşlem başarısız oldu!",
        });
      }
    } catch (err) {
      console.error(err);
      setFeedback({ show: true, type: "error", message: yuklemeHataMesaji(err) });
    }
  };

  return (
    <Layout>
      <h2 className="fw-bold mb-4">Fabrika Hatırlatıcı</h2>

      <Card className="p-3 mb-4 shadow-sm border-0">
        <Row className="align-items-center g-3">
          <Col md={6}>
            <Form.Control
              type="text"
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>
          <Col md={6} className="text-end">
            <Button variant="primary" onClick={handleShow}>
              Yeni Ekle
            </Button>
          </Col>
        </Row>
      </Card>

      <Card className="shadow-sm border-0">
        <Table hover responsive className="mb-0 align-middle">
          <thead className="table-light">
            <tr>
              <th>Durum</th>
              <th>Başlık</th>
              <th>Açıklama</th>
              <th>Kategori</th>
              <th>Başlangıç</th>
              <th>Bitiş</th>
              <th>Yükleyen Kişi</th>
              <th>Döküman</th>
              <th>Düzenle</th>
            </tr>
          </thead>
          <tbody>
            {filteredDocs.length > 0 ? (
              filteredDocs.map((d) => (
                <tr key={d._id}>
                  <td>
                    {(() => {
                      switch (d.status) {
                        case "active":
                          return "Aktif";
                        case "expired":
                          return "Süresi Dolmuş";
                        default:
                          return d.status || "-";
                      }
                    })()}
                  </td>{" "}
                  <td>{d.name}</td>
                  <td>{d.description}</td>
                  <td>{d.category}</td>
                  <td>{new Date(d.createdDate).toLocaleDateString("tr-TR")}</td>
                  <td>{new Date(d.endDate).toLocaleDateString("tr-TR")}</td>
                  <td>
                    {typeof d.personelId === "object"
                      ? `${d.personelId?.name || ""} ${
                          d.personelId?.surname || ""
                        }`.trim()
                      : d.personelId || "Bulunamadı"}
                  </td>
                  <td>
                    {d.fileName ? (
                      <a
                        href={`http://localhost:3001/${d.fileName}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Dökümana Git
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => handleEdit(d)}
                    >
                      <FiEdit /> {/* ✏️ ikonu */}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center text-muted py-4">
                  Kayıt bulunamadı
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Card>

      {/* Yeni Ekle Modal */}
      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {editMode ? "Hatırlatıcıyı Düzenle" : "Yeni Hatırlatıcı Ekle"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Name */}
            <Form.Group className="mb-3">
              <Form.Label>Adı</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={newDoc.name}
                onChange={handleChange}
                placeholder="Örn: Yangın Tüpleri"
              />
            </Form.Group>

            {/* Description */}
            <Form.Group className="mb-3">
              <Form.Label>Açıklama</Form.Label>
              <Form.Control
                type="text"
                name="description"
                value={newDoc.description}
                onChange={handleChange}
                placeholder="Örn: Yangın tüplerini kontrol ettim ıslak imzalı listeyi yükledim"
              />
            </Form.Group>

            {/* Category */}
            <Form.Group className="mb-3">
              <Form.Label>Kategori</Form.Label>
              <Form.Control
                type="text"
                name="category"
                value={newDoc.category}
                onChange={handleChange}
                placeholder="document"
              />
            </Form.Group>

            {/* Created Date */}
            <Form.Group className="mb-3">
              <Form.Label>Başlangıç Tarihi</Form.Label>
              <Form.Control
                type="date"
                name="createdDate"
                value={newDoc.createdDate}
                onChange={handleChange}
              />
            </Form.Group>

            {/* End Date */}
            <Form.Group className="mb-3">
              <Form.Label>Bitiş Tarihi</Form.Label>
              <Form.Control
                type="date"
                name="endDate"
                value={newDoc.endDate}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Notify Before */}
            <Form.Group className="mb-3">
              <Form.Label>Hatırlatma Günleri (virgülle ayır)</Form.Label>
              <Form.Control
                type="text"
                name="notifyBefore"
                value={
                  Array.isArray(newDoc.notifyBefore)
                    ? newDoc.notifyBefore.join(",")
                    : newDoc.notifyBefore
                }
                onChange={handleChange}
                placeholder="7,1"
              />
            </Form.Group>

            {/* Responsible Users */}
            <Form.Group className="mb-3">
              <Form.Label>Ek Sorumlular</Form.Label>
              <Select
                isMulti
                options={userOptions}
                value={userOptions.filter((opt) =>
                  newDoc.responseblePersonel?.some(
                    (p) => p.personelId === opt.value
                  )
                )}
                onChange={handleUserChange}
                placeholder="Personel seçiniz..."
              />
            </Form.Group>

            {/* File */}
            <Form.Group className="mb-3">
              <Form.Label>Dosya</Form.Label>

              {/* Düzenleme modunda mevcut dosya varsa göster */}
              {editMode && newDoc.fileName && !newDoc.file && (
                <div className="mb-2">
                  <a
                    href={`http://localhost:3001/${newDoc.fileName}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Mevcut dosyayı görüntüle
                  </a>
                </div>
              )}

              {/* Yeni dosya seçme alanı */}
              <Form.Control type="file" name="file" onChange={handleChange} />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            İptal
          </Button>
          <Button variant="primary" onClick={handleSave}>
            {editMode ? "Güncelle" : "Kaydet"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Feedback Modal */}
      <Modal
        show={feedback.show}
        onHide={() => setFeedback({ ...feedback, show: false })}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {feedback.type === "success" ? "Başarılı" : "Hata"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{feedback.message}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setFeedback({ ...feedback, show: false })}
          >
            Kapat
          </Button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
}

export default ReminderDocument;
